import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { postVenue } from "@/api/venues";

export default function VenueForm({ venue }) {
    const [name, setName] = useState(venue?.name || "");
    const [street, setStreet] = useState(venue?.street || "");
    const [town, setTown] = useState(venue?.town || "");
    const [postcode, setPostcode] = useState(venue?.postcode || "");
    const [tel, setTel] = useState(venue?.tel || "");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            name,
            street,
            town,
            postcode,
            tel,
        };

        console.log('submitting')

        const response = await postVenue(payload);
        setLoading(false);

        if (response?.id) navigate(`/admin/venues/${response.id}`);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <Label htmlFor="name">Name</Label>
                <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required />
            </div>

            <div>
                <Label htmlFor="street">Street</Label>
                <Input id="street" value={street} onChange={(e) => setStreet(e.target.value)} required />
            </div>

            <div>
                <Label htmlFor="town">Town</Label>
                <Input id="town" value={town} onChange={(e) => setTown(e.target.value)} required />
            </div>

            <div>
                <Label htmlFor="postcode">Postcode</Label>
                <Input id="postcode" value={postcode} onChange={(e) => setPostcode(e.target.value)} required />
            </div>

            <div>
                <Label htmlFor="tel">Telephone</Label>
                <Input id="tel" value={tel} onChange={(e) => setTel(e.target.value)} required />
            </div>

            <Button type="submit" disabled={loading}>
                Save Venue
            </Button>
        </form>
    );
}
